import { Organization } from 'generated-graphql/types';
import { atom } from 'recoil';
import { sessionStorageEffect } from 'services/storage/sessionStorage';

enum StateKey {
  OrganizationGroupOrganizationsState = 'OrganizationGroupOrganizationsState'
}

export const organizationGroupOrganizationsAtom = atom<Organization[] | null>({
  key: StateKey.OrganizationGroupOrganizationsState,
  default: null,
  effects: [sessionStorageEffect(StateKey.OrganizationGroupOrganizationsState)]
});
